import { Link } from "react-router-dom";
import { categoryMetas } from "@/mocks/content";
import { contentItems } from "@/mocks/content";

export default function CategoryEntries() {
  return (
    <section className="w-full">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-950">内容分类</h2>
          <p className="mt-1 text-sm text-foreground-600">按兴趣快速进入对应板块</p>
        </div>
        <Link to="/category" className="text-sm font-medium text-accent-600 hover:text-accent-700">
          查看全部 <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {categoryMetas.map((meta) => {
          const count = contentItems.filter((i) => i.type === meta.type).length;
          return (
            <Link
              key={meta.type}
              to={meta.path}
              className="group flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${meta.icon} text-3xl`} />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-base font-bold text-foreground-950">{meta.name}</h3>
                <p className="mt-0.5 line-clamp-1 text-xs text-foreground-600">{meta.intro}</p>
                <p className="mt-1 font-label text-xs font-medium text-primary-600">{count} 条内容</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}